import { Component, OnInit, OnDestroy } from '@angular/core';
import { DbmanagerService} from '../services/dbmanager.service';
import { LocationItem, EventItem, UserItem } from './../models/Item';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css']
})
export class MapsComponent implements OnInit, OnDestroy {

  public positionsOnMap: Map<string, Element >;

  public items: Array<Mapitem>;
  public locations: Map<string, LocationItem>;
  public descv = false;
  public currentLocation: LocationItem;
  public currentSize = '';
  public currentState = '';
  public currentLastEntry: Date ;
  public currentPerson = '';
  public currentCategory = '';
  private markedId = '' ;
  public saveButton = false;
  private locationSubscriber;
  private itemsSubscriber;
  public selectedLocation = '';

  constructor(private dbservice: DbmanagerService, private router: Router) {
    this.currentLastEntry = new Date();
    this.positionsOnMap = new  Map<string, Element >();
    this.items = new Array<Mapitem>();
    this.locations = dbservice.locations;
    if (this.locations.size > 0)  {
      this.selectedLocation = this.locations.values().next().value.NAME;
      this.locationChanged(this.selectedLocation) ;
    }
   }

  ngOnInit(): void {
    this.locationSubscriber = this.dbservice.getLocations().subscribe(locations => {
      this.locations = locations;
      this.updateEvents();
    });

    this.itemsSubscriber = this.dbservice.getItems().subscribe( items => {
      this.updateEvents();
    });
  }

  ngOnDestroy() {
    this.locationSubscriber.unsubscribe();
    this.itemsSubscriber.unsubscribe();
  }

  updateEvents(): void {
    this.items = [];
    this.dbservice.eventItems.forEach(event => {
       if ((this.currentLocation !== undefined) && (event.LOCATION === this.currentLocation.NAME)) {
        let x = -100;
        let y = -100;
        try {
          x = event.COORD['A0'].X ;
          y = event.COORD['A0'].Y;
        } catch {

        }
        const tag = this.dbservice.tagItems.get(event.TAG_UID) ;
        let user;
        let date;
        if (tag.EDIT_DATETIME > event.EVENT_DATETIME) {
          user = this.dbservice.users.get(tag.USER_ID) ;
          date = tag.EDIT_DATETIME;
        } else {
          user = this.dbservice.users.get(event.USER_ID) ;
          date = event.EVENT_DATETIME;
        }
        this.items.push(new Mapitem(
          tag.DESCRIPTION,
          tag.TITLE,
          event.TAG_UID,
          x,
          y,
          tag.SIZE,
          event.STATE,
          tag.CATEGORY,
          date,
          false,
          user.NAME + ' ' + user.SURNAME));
      }
    });
  }

  locationChanged(locationName) {
    this.currentLocation = undefined;
    this.saveButton = false;
    this.locations.forEach( loc => {
      if (loc.NAME === locationName) {
        this.currentLocation = loc;
        this.updateEvents();
        return;
      }
    });

    if (this.currentLocation === undefined) {
      this.items = [];
      this.getMap();
    }
  }

  getType(): string {
    return this.dbservice.type;
  }

  tagMarked(): boolean {
    return (this.markedId.length !== 0);
  }

  posHover(element, ID) {
    if (this.markedId.length === 0) {
      element.setAttribute('src', '/assets/locm.png');
      this.updateItemData(ID);
    }
  }

  openTag() {
    if (this.markedId.length > 0) {
      this.router.navigate(['/itemdetails'], {
        queryParams: {
          UID: this.markedId
        }
      });
    }
  }

  posUnhover(element) {
    if (this.markedId.length === 0) {
      this.descv = false;
      element.setAttribute('src', '/assets/loc.png');
    }
  }

  posLoaded(element, UID) {
    this.positionsOnMap.set(UID, element);
  }

  mapClicked(event) {
    if (this.markedId.length > 0) {
      this.items.forEach(mapItem => {
        if (mapItem.ID === this.markedId) {
          mapItem.edited = true;
          mapItem.X = 100 * event.offsetX / event.target.clientWidth ;
          mapItem.Y = 100 * event.offsetY / event.target.clientHeight ;
          (this.positionsOnMap.get(mapItem.ID) as HTMLElement).style.opacity = '1';
          this.saveButton = true;
        }
      });
      this.markedId = '';
    }
  }

  saveData() {
    this.saveButton = false ;

    this.items.forEach(mapItem => {
    if (mapItem.edited) {
      mapItem.edited = false;
      let eventData = new Object();
      eventData = Object.assign(eventData, {COORD: {A0: {X: mapItem.X, Y: mapItem.Y}}});
      eventData = Object.assign(eventData, {EVENT_DATETIME: new Date()});
      eventData = Object.assign(eventData, {USER_ID: this.dbservice.currentUserID});
      this.dbservice.updateEventItem(mapItem.ID, eventData);
      }
    });
  }

  itemClicked(ID) {
    if ((this.markedId.length > 0) && (this.markedId !== ID)) {
      (this.positionsOnMap.get(this.markedId) as HTMLElement).style.opacity = '1';
      this.markedId = '';
    }
    if (this.markedId === ID) {
      (this.positionsOnMap.get(ID) as HTMLElement).style.opacity = '1';
      this.markedId = '';
    } else {
      (this.positionsOnMap.get(ID) as HTMLElement).style.opacity = '0.3';
      this.markedId = ID;
    }
  }

  saveAvailable() {
    return this.saveButton;
  }

  updateItemData(ID) {
    this.descv = true;
    const tag = this.dbservice.tagItems.get(ID);
    const event = this.dbservice.eventItems.get(ID);
    let user;
    let date;
    if (tag.EDIT_DATETIME > event.EVENT_DATETIME) {
      user = this.dbservice.users.get(tag.USER_ID) ;
      date = tag.EDIT_DATETIME;
    } else {
      user = this.dbservice.users.get(event.USER_ID) ;
      date = event.EVENT_DATETIME;
    }

    this.currentSize = this.dbservice.tagItems.get(ID).SIZE;
    this.currentState = event.STATE;
    this.currentLastEntry = date.toDate();
    this.currentPerson = user.NAME + ' ' +  user.SURNAME;
    this.currentCategory = this.dbservice.tagItems.get(ID).CATEGORY;
  }

  itemListHover(ID) {
    if (this.positionsOnMap.has(ID)) {
      this.positionsOnMap.get(ID).setAttribute('src', '/assets/locm.png');
      this.updateItemData(ID);
    }
  }

  itemListUnhover(ID) {
    if (this.positionsOnMap.has(ID)) {
      this.positionsOnMap.get(ID).setAttribute('src', '/assets/loc.png');
      this.descv = false;
    }
  }

  getMap() {
    if ((this.currentLocation !== undefined) &&
        (this.currentLocation.MAP.has('A0')) &&
        (this.currentLocation.MAP.get('A0')).length > 0) {

          return this.currentLocation.MAP.get('A0') ;
    }
    return '/assets/placeholder.png';
  }

}

class Mapitem {
  constructor(public Desription: string ,
              public Title: string ,
              public ID: string,
              public X: number,
              public Y: number,
              public size: string,
              public state: string,
              public category: string,
              public lastentry: Date,
              public edited: boolean,
              public person: string) { }
}
